import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BackendListModel } from "src/app/models/common/list.model";
import { DepartmentModel } from "src/app/models/department";
import { ApiRoutes } from "../apiroutes";

@Injectable({
  providedIn: 'root'
})

export class DepartmentApiService {
  base_url = ApiRoutes.Company;

  constructor(private http: HttpClient) { }

  // GET Departments
  getDepartment(page_size = '', page = '', search = '', order = ''): Observable<BackendListModel<DepartmentModel>> {
    let url = `${this.base_url}department/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('name', String(search));
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<DepartmentModel>>(String(urlObj));
  }

  getDepartment1(page_size = '', page = ''): Observable<BackendListModel<DepartmentModel>> {
    let url = `${this.base_url}department/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', '100');
    urlObj.searchParams.append('page', String(page));
    return this.http.get<BackendListModel<DepartmentModel>>(String(urlObj));
  }

  // GET Departments by ID
  getDepartmentById(deptId: string): Observable<DepartmentModel> {
    let url = `${this.base_url}department/${deptId}/`;
    return this.http.get<DepartmentModel>(url);
  }

  // POST Departments
  postDepartment(data: DepartmentModel) {
    let url = `${this.base_url}department/`;
    return this.http.post<DepartmentModel>(url, data);
  }

  // PUT Departments
  updateDepartment(deptId: string, data: DepartmentModel) {
    let url = `${this.base_url}department/${deptId}/`;
    return this.http.put<DepartmentModel>(url, data);
  }
}